import {CustomMarkers} from "@/lib/editor";
import xmlFormat from "xml-formatter";

const checkErrorXML = (x: HTMLElement | ChildNode, xt:Array<string| null>) => {
    let l,i,nam;
    nam=x.nodeName
    if (nam=="h3")
    {
        return;
    }
    if (nam=="#text")
    {
        xt.push(x.nodeValue);
    }
    l=x.childNodes.length
    for (i=0;i<l;i++)
    {
        checkErrorXML(x.childNodes[i], xt)
    }
}
/**
 *
 * @param error - Example "error on line 7 at column 8: Opening and ending tag mismatch: to line 3 and note"
 */
const getMarkerDetails = (error: string): {line: number; column: number} => {
    const line = Number(error.split("line ")[1].split(" ")[0]);
    const column = Number(error.split("column ")[1].split(" ")[0].replace(":", ""));
    return {line, column }
}


export const validateXML = (xmlText: string): Array<CustomMarkers> | undefined => {
// code for Mozilla, Firefox, Opera, etc.
    if (document.implementation)
    {
        const errorsList: Array<string>= [];
        var parser=new DOMParser();
        var xmlDoc=parser.parseFromString(xmlText,"application/xml");

        if (xmlDoc.getElementsByTagName("parsererror").length>0)
        {
            checkErrorXML(xmlDoc.getElementsByTagName("parsererror")[0], errorsList);
            return errorsList.map((errorMessage) => {
                const errorMarker = getMarkerDetails(errorMessage)
                const error: CustomMarkers = {
                    line: errorMarker.line,
                    column: errorMarker.column,
                    message: errorMessage
                }
                return error;
            })
        }
    }
    else
    {
        console.log('Your browser cannot handle XML validation');
    }
}

export const XMLFormatter = (value: string ) => xmlFormat(value)
